import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
export class RowGroupInbox extends RowBase<GroupInbox> {
  constructor(origin: GroupInbox) {
    super(origin)

    makeObservableRowBase(this, {
      members: computed,
      inboxesCount: computed,
      createdAt: computed,
    })
  }

  get members() {
    return this.origin.origin.teams
  }

  get inboxesCount() {
    return this.origin.teamsIds.length
  }

  get createdAt() {
    return this.origin.origin.created_at
  }
}
